import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import '@fortawesome/fontawesome-free/css/regular.min.css';
import 'leaflet/dist/leaflet.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';

const toastOptions = {
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  position: 'bottom-right',
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
  maxToasts: 3,
  transition: 'Vue-Toastification__fade',
  newestOnTop: true,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter((t) => t.content === toast.content).length !== 0) {
      return false;
    }
    return toast;
  },
};

const initAos = () => {
  const loadAos = async () => {
    const [{ default: AOS }] = await Promise.all([import('aos'), import('aos/dist/aos.css')]);

    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });
  };

  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(() => loadAos(), { timeout: 3500 });
  } else {
    setTimeout(loadAos, 1500);
  }
};

function bootstrap() {
  const app = createApp(App);
  app.use(router);
  app.use(store);
  app.mount('#app');
  initAos();

  void (async () => {
    const [{ default: Toast }] = await Promise.all([
      import(/* webpackChunkName: "toast" */ 'vue-toastification'),
      import(/* webpackChunkName: "toast" */ 'vue-toastification/dist/index.css'),
    ]);
    app.use(Toast, toastOptions);
  })();
}

bootstrap();
